import React, { useState } from "react";
import { NoEmployees } from "./NoEmployees";
import {
  EmployeeActions,
  EmployeeArea,
  EmployeeDuration,
  EmployeeInfo,
  EmployeePosition,
} from "./EmployeeTableRow";
import { Icon, Loader, Table } from "semantic-ui-react";
import { useAsync } from "react-async";
import { AxiosEmployeeManagerAPI } from "../Api";
import { ErrorSegment } from "../../common/components/ErrorSegment";

export const EmployeeExpandableCell = ({ setOpen, employee, deep, open }) => {
  const colors = ["#707070", "#959595"];
  const isManager = employee.is_manager;
  const style = {
    cursor: "pointer",
    marginLeft: deep * 10,
    borderLeft: `8px solid ${colors[deep % 2]}`,
    paddingLeft: 10,
    display: "flex",
  };
  if (isManager) {
    return (
      <span role="presentation" onClick={() => setOpen(!open)} style={style}>
        <EmployeeInfo employee={employee} />
        <Icon
          style={{ lineHeight: 1.4 }}
          size={"big"}
          color={"grey"}
          name={open ? "angle up" : "angle down"}
        />
      </span>
    );
  }
  return (
    <span role="presentation" style={style}>
      <EmployeeInfo employee={employee} />
    </span>
  );
};

export const EmployeeTeamTableRow = ({ employee, reload, deep }) => {
  const [open, setOpen] = useState(false);
  let area = employee.current_area?.area;
  let position = employee.current_position?.position;

  return (
    <>
      <Table.Row id={employee.id}>
        <Table.Cell id={"name"}>
          <EmployeeExpandableCell
            employee={employee}
            setOpen={setOpen}
            open={open}
            deep={deep}
          />
        </Table.Cell>
        <Table.Cell id={"time"}>
          <EmployeeDuration employee={employee} />
        </Table.Cell>
        <Table.Cell id={"position"}>
          <EmployeePosition position={position} />
        </Table.Cell>
        <Table.Cell id={"area"}>
          <EmployeeArea area={area} />
        </Table.Cell>
        <Table.Cell id={"actions"}>
          <EmployeeActions employee={employee} reload={reload} disableEdit />
        </Table.Cell>
      </Table.Row>
      {open ? (
        <EmployeeTeamTable employee_id={employee.id} deep={deep + 1} />
      ) : null}
    </>
  );
};

const EmployeeTeam = ({ employees, reload, deep }) => {
  return employees.map((employee) => (
    <EmployeeTeamTableRow
      key={employee.id}
      employee={employee}
      reload={reload}
      deep={deep}
    />
  ));
};

const EmployeeTeamTable = ({ employee_id, deep }) => {
  const { data, isPending, error, reload } = useAsync({
    promiseFn: AxiosEmployeeManagerAPI.getTeam,
    watch: employee_id,
    employee_id: employee_id,
  });
  if (isPending) return <Loader active />;
  if (error) return <ErrorSegment message={error.message} />;

  if (data.length === 0) {
    return <NoEmployees message="Este funcionário não possui time!" />;
  }

  return <EmployeeTeam employees={data} reload={reload} deep={deep} />;
};

export const EmployeeTeamList = ({ employee_id }) => {
  if (employee_id)
    return (
      <Table selectable padded="very" style={{ marginBottom: "2rem" }}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Nome</Table.HeaderCell>
            <Table.HeaderCell>No time desde</Table.HeaderCell>
            <Table.HeaderCell>Cargo</Table.HeaderCell>
            <Table.HeaderCell>Área</Table.HeaderCell>
            <Table.HeaderCell>Ações</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <EmployeeTeamTable employee_id={employee_id} deep={0} />
        </Table.Body>
      </Table>
    );

  return null;
};
